import React from 'react';
import { Switch, Route, HashRouter, BrowserRouter } from 'react-router-dom';
import PageNotFound from './components/pages/PageNotFoundPage/PageNotFound';
import { ShopProvider } from './contexts/ShopContext';
import { PaymentProvider } from './contexts/PaymentContext';
import ShopHomePage from './components/pages/HomePage/ShopHomePage';
import ShopSelectPage from './components/pages/ShopList/ShopListPage';
import ProductDetailsPage from './components/pages/ProductDetails/ProductDetailsPage';
import ShopRoute from './components/utils/ShopRoute';
import { CartProvider } from './contexts/CartContext';
import AlertMessagesProvider from 'react-alert-messages';
import OrderDetails from './components/pages/OrderDetails/OrderDetails';
import { ROUTES } from './const';
import { OrderProvider } from './contexts/OrderContext';
import PaymentStatusPage from './components/pages/PaymentStatus/PaymentStatus';
import SaonftContactusPage from './components/pages/Info/sanoftContact';
import PrivacyPolicy from './components/pages/PrivacyPolicy/PrivacyPolicy';
import CartPage from './components/pages/CartPage/Cart';
import CustomerDetailsPage from './components/pages/CustomerDetails/CustomerDetails';
import ProfilePage from './components/pages/Profile/Profilte';
import RefundPolicy from './components/pages/PrivacyPolicy/RefundPolicy';
import ShippingPolicy from './components/pages/PrivacyPolicy/ShippingPolicy';
import Terms from './components/pages/PrivacyPolicy/Terms';
import ContactUs from './components/pages/ContactUs/ContactUs';
import PaymentCallbackPage from './components/pages/PaymentStatus/PaymentCallback';

function App() {
  const Router = process.env.REACT_APP_ROUTER_TYPE === 'hash' ? HashRouter : BrowserRouter;

  return (
    <Router>
      <AlertMessagesProvider>
        <ShopProvider>
          <CartProvider>
            <OrderProvider>
              <PaymentProvider>
                <Switch>
                  <Route exact={true} path="/" component={ShopSelectPage} />
                  <ShopRoute exact={true} path={ROUTES.SHOP_HOME} component={ShopHomePage} />
                  <ShopRoute exact={true} path={ROUTES.CART} component={CartPage} />
                  <ShopRoute exact={true} path={ROUTES.CUSTOMER_DETAILS} component={CustomerDetailsPage} />
                  <ShopRoute exact={true} path={ROUTES.PRODUCT_DETAILS} component={ProductDetailsPage} />
                  <ShopRoute exact={true} path={ROUTES.PROFILE} component={ProfilePage} />
                  <ShopRoute exact={true} path={ROUTES.ORDER_DETAILS} component={OrderDetails} />
                  <ShopRoute exact={true} path={ROUTES.PAYMENT_STATUS} component={PaymentStatusPage} />
                  <ShopRoute exact={true} path={ROUTES.PAYMENT_CALLBACK} component={PaymentCallbackPage} />
                  <ShopRoute exact={true} path={ROUTES.CONTACT_US} component={ContactUs} />
                  <ShopRoute exact={true} path={ROUTES.SANOFT_CONTACT_US} component={SaonftContactusPage} />
                  <ShopRoute exact={true} path={ROUTES.PIVACY_POLICY} component={PrivacyPolicy} />
                  <ShopRoute exact={true} path={ROUTES.REFUND_POLICY} component={RefundPolicy} />
                  <ShopRoute exact={true} path={ROUTES.SHIPPING_POLICY} component={ShippingPolicy} />
                  <ShopRoute exact={true} path={ROUTES.TERMS_AND_CONDITIONS} component={Terms} />
                  <Route path="/*">
                    <PageNotFound />
                  </Route>
                </Switch>
              </PaymentProvider>
            </OrderProvider>
          </CartProvider>
        </ShopProvider>
      </AlertMessagesProvider>
    </Router>
  );
}

export default App;
